<template>
	<div class="combo-dropdown-panel" :style="dropdownStyles">
		<!-- Phần header của menu khi có grid-->
		<div
			class="dropdown-header-container"
			v-if="columnx && columnx.length > 0 && hasHeader"
		>
			<table class="dropdown-table" :style="headerStyle">
				<thead class="dropdown-header">
					<tr>
						<th class="dropdown-header__th ms-th-serial" v-if="serial">
							<span>{{ $t('i18nCommon.OrderNumber') }}</span>
						</th>
						<th
							class="dropdown-header__th"
							v-for="(column, index) in columnx"
							:key="index"
							:title="column.tooltip"
							:style="getThStyle(column)"
						>
							<span>{{ column.title }}</span>
						</th>
					</tr>
				</thead>
			</table>
		</div>

		<div
			ref="menuBodyCon"
			class="dropdown-body-container"
			@scroll.stop="onDropdownMenuScroll"
			:style="dropdownBodyStyle"
		>
			<!-- Phần nội dung grid combo không có column -->
			<ul ref="dropdownItems" class="dropdown-items" v-if="comboType === 1">
				<slot></slot>
			</ul>
			<!--  -->

			<!-- Phần nội dung grid combo có columns và combo tree -->
			<table class="dropdown-table" v-else>
				<tbody ref="dropdownItems" class="dropdown-items">
					<slot></slot>
				</tbody>
			</table>
			<div
				class="group-button text-center"
				v-if="isShowUnSelectAll && isShowRemoveAll"
			>
				<div class="flex h-36 align-center">
					<span class="btn-unselect-all" @click="removeAll">{{
						$t('i18nCommon.RemoveSelectAll')
					}}</span>
				</div>
			</div>
			<div class="group-button" v-if="isActionAdd">
				<div class="flex h-36 align-center add-new-btn" @click="addClick">
					<div class="mi-new-v2 mi-icon-v2-plus"></div>
					<span class="add-text">{{ $t('i18nCommon.AddSupplierNew') }}</span>
				</div>
			</div>
			<!--  -->
		</div>

		<!-- Hiển thị loading khi chưa có dữ liệu -->
		<div class="dropdown--loading" v-show="loading" @click.stop>
			<div class="loading">
				<div class="effect-1 effects"></div>
			</div>
		</div>
		<!--  -->

		<!-- Show thông báo khi không có dữ liệu hiển thị -->
		<div class="no-data-display" v-if="emptyText" @click.stop>
			<div class="no-data-display__text">{{ emptyText }}</div>
		</div>
		<!--  -->

		<div v-if="isEmptyDataSearch && isCustomEmpty" class="empty-data-wrapper">
			<div class="empty-data-text">{{ isCustomEmpty.text }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MsComboBoxDropdown',
	props: {
		hasHeader: {
			type: Boolean,
			default: false,
		},

		isShowUnSelectAll: {
			type: Boolean,
			default: false,
		},
		/**
		 * Loại combo sử dụng để style cột
		 */
		comboType: {
			type: Number,
			default: 1,
		},
		/**
		 * Số lượng item hiển thị ở dropdown
		 */
		maxItemsDisplay: {
			type: Number,
			default: 5,
		},

		/**
		 * Các cột của dropdown
		 */
		columnx: {
			type: Array,
			default() {
				return [];
			},
		},

		/**
		 * Text hiển thị khi không có dữ liệu
		 * CreatedBy PDKIEN 09/12/2019
		 */
		emptyText: {
			type: String,
			default: 'Không có dữ liệu!',
		},

		/**
		 * Trạng thái `loading`
		 */
		loading: {
			type: Boolean,
			default: false,
		},
		/**
		 * Độ rộng phần dropdown, nếu bằng <=0 hoặc Auto sẽ tự động tính toán
		 * CreatedBy PDKIEN 09/12/2019
		 */
		dropdownWidth: {
			type: [Number, String],
			default: 0,
		},
		/**
		 * Có dữ liệu  hay  không
		 * CreatedBy PDKIEN 10/112/2019
		 */
		hasData: {
			type: Boolean,
			default: true,
		},
		topx: {
			type: Number,
			default: null,
		},
		leftx: {
			type: Number,
			default: null,
		},
		maxWidthx: {
			type: Number,
			default: null,
		},
		minWidthx: {
			type: Number,
			default: null,
		},
		serial: {
			default: false,
			type: Boolean,
		},
		isCustomEmpty: {
			default: null,
			type: Object,
		},
		isEmptyDataSearch: {
			default: false,
			type: Boolean,
		},
		//Có cho phép hiển thị chức năng bỏ chọn tất cả hay không
		isShowRemoveAll: {
			default: true,
			type: Boolean,
		},
		/**
		 * Cho phép hành đồng action add trong drop down combobox
		 */
		isActionAdd: {
			default: false,
			type: Boolean,
		},
		isChangeDataSelected: {
			default: false,
			type: Boolean,
		},
		isAutoChangeDropdownStyle: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			test: false,
		};
	},
	computed: {
		headerStyle() {
			return {
				width: this.headerWidth + 'px',
			};
		},

		headerWidth() {
			let width = 0;
			this.test = true;
			if (this.columnx && this.columnx.length > 0) {
				for (let index = 0; index < this.columnx.length; index++) {
					const element = this.columnx[index];
					if (element.width) {
						width = width + element.width;
					}
				}
			}
			width += 40;
			// Data row luôn có thêm cột icon tick (.selected-container, 56px) mà công thức header
			// gốc không tính vào — khiến header/panel luôn hẹp hơn content thực tế, gây mất góc
			// border cuối header hoặc icon tick bị che ở lề phải. Cộng bù cố định 56px ở đây.
			width += 56;
			return width;
		},
		/**
		 * Style cho dropdown
		 */
		dropdownStyles() {
			let width = this.headerWidth,
				docWidth = document.body.clientWidth,
				left = this.leftx;
			if (left + width + this.dropdownWidth > docWidth) {
				left = left - (width + left + this.dropdownWidth - docWidth);
			}

			return {
				top: this.topx + 'px',
				left: left + 'px',
				minWidth: this.minWidthx + 'px',
				maxWidth: this.forceMaxWidth ? this.maxWidthx + 'px' : null,
			};
		},

		/**
		 * Set lại chiều cao tối đa của dropdown nếu số lượng item hiển thị khác default
		 */
		dropdownBodyStyle() {
			const me = this;
			if (me.maxItemsDisplay !== 5) {
				return {
					maxHeight: `${me.maxItemsDisplay * 36}px`,
				};
			}
		},
	},
	watch: {
		isChangeDataSelected: {
			handler(newVal, oldVal) {},
		},
	},
	methods: {
		removeAll() {
			this.$emit('removeAll');
		},
		/**
		 * Hàm lấy style cho th trong table
		 * dữ liệu động theo config của dev
		 */
		getThStyle(column) {
			return {
				width: column.isResize ? null : `${column.width}px`,
				textAlign: column.titleAlign,
			};
		},

		/**
		 * Xử lý sự kiện click bất kỳ đâu trên document
		 */
		onDocumentClick(event) {
			let me = this,
				targetCombo = event.target.closest('.ms-combo'),
				comboEl = me.$parent.$el;

			if (targetCombo !== comboEl) {
				me.$parent.collapse();
			}
		},

		/**
		 * Sự kiện khi scroll dropdown menu
		 */
		onDropdownMenuScroll(e) {
			let target = e.target;
			// kiểm tra nếu scroll to bottom
			if (target.scrollTop === target.scrollHeight - target.offsetHeight) {
			}
		},

		/**
		 * Xử lý sự kiện scroll document
		 * - Đóng menu
		 */
		onDocumentScroll(event) {
			let me = this,
				comboMenu = event.target.closest('.combo-dropdown-panel');
			if (!comboMenu || comboMenu !== me.$el) {
				me.$parent.collapse();
			}
		},

		onWindowResize() {
			const me = this;
			me.$parent.collapse();
		},

		/**
		 * Hàm append dropdown menu vào thẻ body
		 * append vào trước phần tử đầu tiên trong thẻ body
		 */
		insertBody() {
			let me = this,
				elm = me.$el;
			document.body.insertBefore(elm, document.body.firstChild);
		},

		addClick() {
			this.$emit('addClick');
		},
	},
	mounted() {
		const me = this;

		// Append menu vào thẻ body
		me.insertBody();
		// Thêm event click vào document
		// document.addEventListener('click', me.onDocumentClick);

		// document.addEventListener('scroll', me.onDocumentScroll, true);

		// window.addEventListener('resize', me.onWindowResize);
	},
	beforeDestroy() {
		const me = this;

		// me.$el.parentNode.removeChild(me.$el);

		// document.removeEventListener('click', me.onDocumentClick);

		// document.removeEventListener('scroll', me.onDocumentScroll, true);

		// window.removeEventListener('resize', me.onWindowResize);
	},
};
</script>


<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msComboboxDropdown.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msComboboxDropdown.scss';
}
.ms-th-serial {
	min-width: 50px;
	width: 50px;
	max-width: 50px;
}
.add-text {
	color: $ms-color-primary;
	&:hover {
		color: $ms-color-primary-hover;
	}
}
.cusor-pointer {
	cursor: pointer;
}
</style>

